import React from 'react';

import Typography from '@mui/material/Typography';

import { RowContainer } from './styledInfoComponents';

interface Props {}

const NotesRow = (props: React.PropsWithChildren<Props>) => {
    return (
        <RowContainer border={false}>
            <Typography fontWeight="bold" whiteSpace="pre-wrap" maxHeight={80}>
                {props.children}
            </Typography>
        </RowContainer>
    );
};

export default NotesRow;
